import { Button, CircularProgress } from '@material-ui/core'

const ButtonSp = ({
  children,
  style,
  elevation = false,
  color = 'primary',
  variant = 'contained',
  loading = false,
  disabled = false,
  fontSize = 16,
  ...props
}) => {
  return (
    <Button
      disableElevation={!elevation}
      color={color}
      variant={variant}
      style={
        style
          ? { ...style, fontWeight: 400, fontSize: fontSize }
          : { fontWeight: 400, fontSize: fontSize }
      }
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <CircularProgress color="primary" size={24} /> : children}
    </Button>
  )
}

export default ButtonSp
